import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { CompletionStatuses } from '../../../../../constants';
import { useTracker } from '../../../../../context/hooks';
import { SeoRecommendations } from '../../../../constants';
import { RecommendationBaseView } from '../../../../sharedComponents/RecommendationBaseView';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubtopicPhrasesList = ({
  subtopicPhrases
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.subHeader.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
      })
    }), /*#__PURE__*/_jsx(ExpandableText, {
      maxHeight: 128,
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockEnd: "0",
        wrapChildren: true,
        children: subtopicPhrases.map((phrase, key) => {
          return /*#__PURE__*/_jsx("span", {
            children: phrase
          }, key);
        })
      })
    })]
  });
};
export const IncreaseClusterPhraseInBodyCountView = ({
  auditResult
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    subtopicPhrases
  } = auditResult;
  const showSubtopicPhrases = status === CompletionStatuses.INCOMPLETE && subtopicPhrases;
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
    }),
    status: status,
    children: [showSubtopicPhrases && /*#__PURE__*/_jsx(SubtopicPhrasesList, {
      subtopicPhrases: subtopicPhrases
    }), /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "600",
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(Link, {
        href: "https://knowledge.hubspot.com/articles/kcs_article/content-strategy/pillar-pages-topics-and-subtopics#subtopic",
        external: true,
        onClick: handleClickKBLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
        })
      })
    })]
  });
};